<ng-content></ng-content>
<i *ngIf="sortDirection === 'asc'" class="fa fa-chevron-up"></i>
<i *ngIf="sortDirection === 'desc'" class="fa fa-chevron-down"></i>
